export const OPEN_FLOW_DEBUGGER = 'OPEN_FLOW_DEBUGGER';
export const CLOSE_FLOW_DEBUGGER = 'CLOSE_FLOW_DEBUGGER';

export const CLEAR_SELECTED_LOG = 'CLEAR_SELECTED_LOG';

export const SET_DEBUGGER_LOG = 'SET_DEBUGGER_LOG';
export const SET_DEBUGGER_LOG_START = `${SET_DEBUGGER_LOG}_START`;
export const SET_DEBUGGER_LOG_SUCCESS = `${SET_DEBUGGER_LOG}_SUCCESS`;
export const SET_DEBUGGER_LOG_FAIL = `${SET_DEBUGGER_LOG}_FAIL`;

export const SET_STEP_RESULTS = 'SET_STEP_RESULTS';
export const SET_STEP_RESULTS_START = `${SET_STEP_RESULTS}_START`;
export const SET_STEP_RESULTS_SUCCESS = `${SET_STEP_RESULTS}_SUCCESS`;
export const SET_STEP_RESULTS_FAIL = `${SET_STEP_RESULTS}_FAIL`;

export const SET_FLOW_ACTIVITY_FILTERS = 'SET_FLOW_ACTIVITY_FILTERS';

export const SET_DATE_TYPE_FILTER = 'SET_DATE_TYPE_FILTER';

export function openDebugger(filters) {
  return {
    type: OPEN_FLOW_DEBUGGER,
    payload: { filters },
  };
}

export function closeDebugger() {
  return { type: CLOSE_FLOW_DEBUGGER };
}

export const FLOW_ACTIVITY_SET_SELECTED_REQUEST =
  'FLOW_ACTIVITY_SET_SELECTED_REQUEST';
export function setSelectedRequest(request) {
  return { type: FLOW_ACTIVITY_SET_SELECTED_REQUEST, payload: request };
}

export const FLOW_ACTIVITY_SET_SELECTED_STEP_ID =
  'FLOW_ACTIVITY_SET_SELECTED_STEP_ID';
export function setSelectedStepId(stepId) {
  return { type: FLOW_ACTIVITY_SET_SELECTED_STEP_ID, payload: stepId };
}

export function clearSelectedLog() {
  return { type: CLEAR_SELECTED_LOG };
}

export function setDebuggerLog(canvasId, log) {
  return {
    type: SET_DEBUGGER_LOG,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/flow-canvases/${canvasId}/logs/${log.id}`,
      method: 'get',
      params: {
        embed: 'JOB,callerLog',
      },
    },
  };
}

export function setStepResults(canvasId, logId, stepId) {
  return {
    type: SET_STEP_RESULTS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/flow-canvases/${canvasId}/logs/${logId}/step-results/${stepId}`,
      method: 'get',
      params: {
        embed: 'callableLog',
      },
    },
  };
}

export function setActivityFilters(filters) {
  return {
    type: SET_FLOW_ACTIVITY_FILTERS,
    payload: { filters },
  };
}

export function setSelectedDateTypeFilter(dateType) {
  return {
    type: SET_DATE_TYPE_FILTER,
    payload: dateType,
  };
}
